import React from 'react';
import { FlexGrid, FlexGridColumn } from '@grapecity/wijmo.react.grid';

const hearingLossData = [
  {
    category: "Age-Related Hearing Loss",
    description: "Gradual loss of hearing that naturally occurs with aging.",
    example: "Presbycusis.",
  },
  {
    category: "Non-Occupational Medical Condition",
    description: "Hearing loss caused by a health issue unrelated to work.",
    example: "Autoimmune disorder, chronic ear infection.",
  },
  {
    category: "Non-Occupational Noise Exposure",
    description: "Hearing damage from loud sounds outside the workplace.",
    example: "Concerts, hunting, loud power tools at home.",
  },
  {
    category: "Non-Occupational Ototoxic Medication or Chemical",
    description:
      "Hearing loss from drugs or chemicals taken/encountered outside of work.",
    example: "Chemotherapy medication, high-dose aspirin, household solvents.",
  },
  {
    category: "Non-Occupational Trauma or Injury",
    description:
      "Hearing loss due to accidents or injuries outside the workplace.",
    example: "Sports injury, car accident causing ear damage.",
  },
  {
    category: "Other (Non-Occupational)",
    description: "Any non-work-related cause not listed above.",
    example: "Birth-related hearing loss.",
  },
];

const NonWorkRelated = () => {
  return (
    <div style={{ padding: '0px 30px' }}>
      <>
        <FlexGrid
          id='theGridTallRows'
          className='LegendTable cliniclisttable'
          itemsSource={hearingLossData}
          isReadOnly={true}
          headersVisibility="Column"
          style={{ height: 'auto', width: '75%', overflowX: 'auto' }}
        >
          <FlexGridColumn binding='category' header='Category' width="1*" />
          <FlexGridColumn binding='description' header='Description' width="1*" />
          <FlexGridColumn binding='example' header='Example' width="1*" />

        </FlexGrid>
      </>
    </div>
  );
};

export default NonWorkRelated;
